




import { Component, Vue } from 'vue-property-decorator';

@Component({
  name: 'Home',
  metaInfo() {
    return {
      title: 'Home',
    };
  },
})
export default class Home extends Vue {}
